import { render, staticRenderFns } from "./BrandsByNiceClassBarChart.vue?vue&type=template&id=9a1783d4&scoped=true&"
import script from "./BrandsByNiceClassBarChart.vue?vue&type=script&lang=ts&"
export * from "./BrandsByNiceClassBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1783d4",
  null
  
)

export default component.exports